import { render, staticRenderFns } from "./spacePoster.vue?vue&type=template&id=2e68920c&scoped=true&"
import script from "./spacePoster.vue?vue&type=script&lang=js&"
export * from "./spacePoster.vue?vue&type=script&lang=js&"
import style0 from "./spacePoster.vue?vue&type=style&index=0&id=2e68920c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68920c",
  null
  
)

component.options.__file = "spacePoster.vue"
export default component.exports